import { OuiSelectOption } from 'omnium-ui/form-field';
import { CorrectionPreview } from '../../../core/models/api.models';

export function buildReplacementSelections(preview: CorrectionPreview): Record<number, number | null> {
  return Object.fromEntries(
    preview.replacementOptions.map(option => [
      option.linkedInvestor.investorId,
      option.candidates.length === 1 ? option.candidates[0].investorId : null
    ])
  );
}

export function buildReplacementOptionChoices(
  preview: CorrectionPreview
): Partial<Record<number, OuiSelectOption<number>[]>> {
  return Object.fromEntries(
    preview.replacementOptions.map(option => [
      option.linkedInvestor.investorId,
      option.candidates.map(candidate => ({
        label: `${candidate.displayName || 'Investisseur'} (#${candidate.investorId})`,
        value: candidate.investorId
      }))
    ])
  );
}
